<template>
<div>
    <div v-show="loading !== 0">
        <ring-loader></ring-loader>
    </div>
    <span v-if="isCount" v-show="loading === 0">{{ rateCount }}</span>
    <span v-else v-show="loading === 0">{{ rating == null ? 'BRAK' : rating }}</span>
</div>
</template>

<script>
import axios from 'axios'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    RingLoader
  },
  props: {
    mealId: {
      type: [String, Number],
      required: true,
    },
    month: {
      type: [String, Number],
      required: true,
    },
    count: {
      type: [String, Number],
      required: true,
    },
    index: {
      type: [String, Number],
      required: true,
    },
    year: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isCount: this.count,
      rating: null,
      rateCount: null,
      loading: 0
    }
  },
  created() {
    this.loading++
    this.getRateForMonth()
  },
  methods: {
    async getRateForMonth() {
      if (this.$parent.groupedData[this.mealId] &&
          typeof(this.$parent.groupedData[this.mealId].rate) !== 'undefined' &&
          typeof(this.$parent.groupedData[this.mealId].count) !== 'undefined'
      ) {
        this.rating = this.$parent.groupedData[this.mealId].rate
        this.rateCount = this.$parent.groupedData[this.mealId].count
        this.loading--
        if (this.$parent.rowCounter[this.index] !== undefined) {
          this.$parent.rowCounter[this.index]++
        } else {
          this.$parent.rowCounter[this.index] = 1
        }
        if (Number(this.$parent.rowCounter[this.index]) === 6) {
          this.$emit('loadingFinished')
        }
        return
      }
      let url = Routing.generate('rate_for_month', { mealId: this.mealId,
        month: this.month,
        year: this.year })
      const response = await axios.get(
        url, {}
      )
      this.rating = response.data.rate
      this.rateCount = response.data.count
      if (!this.$parent.groupedData[this.mealId]) {
        this.$parent.groupedData[this.mealId] = {}
      }
      this.$parent.groupedData[this.mealId].rate = response.data.rate
      this.$parent.groupedData[this.mealId].count = response.data.count
      this.loading--
      if (this.$parent.rowCounter[this.index] !== undefined) {
        this.$parent.rowCounter[this.index]++
      } else {
        this.$parent.rowCounter[this.index] = 1
      }
      if (Number(this.$parent.rowCounter[this.index]) === 6) {
        this.$emit('loadingFinished')
      }
    }
  }
}
</script>
